export const arrStrFormat = (arr: string[]) =>
  arr.join('').replace(/(\r\n|\n|\r)/gm, '').replace(/ +(?= )/g, '');

export const ENT = '\n';